(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["varaprint-hourly-announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vp-hourly-announcement')) {
    customElements.define('vp-hourly-announcement', class extends HTMLElement {
      connectedCallback() {
        this.onReady = () => this.start();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
        } else {
          this.start();
        }
      }
      start() {
        if (this.started || !this.isConnected) return;
        this.offers = Array.from(this.querySelectorAll('[data-vp-hourly-offer]'));
        if (!this.offers.length) return;
        this.started = true;
        this.onVisibility = () => {
          if (!document.hidden) this.refresh();
        };
        this.onFocusOut = () => queueMicrotask(() => this.refresh());
        document.addEventListener('visibilitychange', this.onVisibility);
        this.addEventListener('focusout', this.onFocusOut);
        this.refresh();
      }
      refresh() {
        clearTimeout(this.timer);
        if (!this.isConnected) return;
        if (!this.contains(document.activeElement)) {
          const hour = Math.floor(Date.now() / 3600000);
          const index = hour % this.offers.length;
          this.offers.forEach((offer, position) => {
            offer.hidden = position !== index;
          });
          this.dataset.activeOffer = this.offers[index].dataset.vpHourlyOffer;
        }
        this.timer = setTimeout(() => this.refresh(), 3600000 - Date.now() % 3600000 + 30);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('DOMContentLoaded', this.onReady);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.removeEventListener('focusout', this.onFocusOut);
        this.started = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
